export default {
    getId: (item) => {
        return item["id"]
    },
    getTitle: (item) => {
        return item["title"]
    },
    getCountShop: (item) => {
        return item["count_shop"]
    },
}
